<script lang="ts">
import Button from "../../../materialize/components/Button.svelte";
import Icon from "../../../materialize/components/Icon.svelte";
import Row from "../../../materialize/grid/Row.svelte";
import AudioButton from "../../../utils/AudioButton.svelte";
import { createEventDispatcher } from 'svelte';
import Center from "../../../materialize/grid/Center.svelte";

const dispatch = createEventDispatcher();
export let audio_path: string;

let audio_has_been_listened: boolean = false;

function fire_event_confirm()
{
    dispatch('confirm', {});
}
function fire_event_cancel()
{
    dispatch('cancel', {});
}</script>

<Center>
    <AudioButton on:ended={()=>{audio_has_been_listened = true}} size="large" {audio_path} ></AudioButton>
</Center>

<div>
    
</div>

{#if audio_has_been_listened}
<Row>
    <Button on:click={fire_event_cancel} size="large" class_list={["left", "approu-error"]}><Icon icon="close"></Icon></Button>
    <Button on:click={fire_event_confirm} size="large" class_list={["right", "approu-primary"]}><Icon icon="check"></Icon></Button>
</Row>
{/if}
